import {Divider, Drawer, Menu} from 'antd';
import PropTypes from 'prop-types';
import {AiOutlineClose, AiOutlineHome, AiOutlineInfoCircle} from 'react-icons/ai';
import {GiSofa} from 'react-icons/gi';
import {GrGallery} from 'react-icons/gr';
import {IoIosArrowForward} from 'react-icons/io';
import {MdOutlineContactMail, MdWorkOutline} from 'react-icons/md';
import {RiFlowChart} from 'react-icons/ri';
import {Link} from 'react-router-dom';

const DrawerComponent = ({open, closeDrawer}) => {
  const menuItems = [
    {name: 'Home', path: '/', icon: <AiOutlineHome />},                 
    {name: 'About', path: '/about', icon: <AiOutlineInfoCircle />},   
    {name: 'Products', path: '/products', icon: <GiSofa />},   
    {name: 'Our Process', path: '/ourProcess', icon: <RiFlowChart />},       
    {name: 'Gallery', path: '/gallery', icon: <GrGallery />},           
    {name: 'Contact Us', path: '/contact-us', icon: <MdOutlineContactMail />},
    {name: 'Careers', path: '/careers', icon: <MdWorkOutline />},

  ];

  return (
    <Drawer
      title={
        <h2 className={'text-lg font-bold'}>Menu</h2>
      }
      placement={'right'}
      onClose={closeDrawer}
      open={open}
      bodyStyle={{
        padding: 0,
      }}
      headerStyle={{
        backgroundColor: '#e6eee9',
        borderBottom: '1px solid #514141',
      }}
      style={{
        backgroundColor: '#e6eee9',
      }}
      width={300}
      className={'bg-primary-950'}
      closeIcon={<AiOutlineClose className={'text-xl'} />}
    >
      <Menu
        mode={'vertical'}
        selectedKeys={[]}
        style={{
          backgroundColor: '#e6eee9',
        }}
        className={'border-none p-0 '}
      >
        {menuItems.map((item, index) => (
          <div key={index}>
            <Menu.Item className={'p-0'}>
              <Link
                to={item.path}
                onClick={closeDrawer}
                className={' cursor-pointer text-base flex justify-between items-center p-4'}
              >
                <div className={'flex items-center '}>
                  <span className={'text-xl mr-3 font-semibold'}>{item.icon}</span>
                  <span className={'text-lg font-semibold'}>{item.name}</span>
                </div>
                <IoIosArrowForward className={'text-secondary-300'} />
              </Link>
            </Menu.Item>
            {index !== menuItems.length - 1 && (
              <Divider className={'my-1 h-[0.2px] bg-secondary-100 border-none'} />
            )}
          </div>
        ))}
      </Menu>
    </Drawer>
  );
};

DrawerComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
};

export default DrawerComponent;
